export default "__VITE_ASSET__Ct2V3$Nv__"